import { computed, makeObservable, observable, toJS } from 'mobx'

import { DTO } from '../DTO'

export class MakeWorksheetByPracticeTestOption extends DTO {
  // 공통
  filterId = '' // 필터 고유 아이디
  onlyAutoScorable = true // 자동채점 가능여부
  excludeOOC = true // 교육과정 외 유형 제외
  practiceProblemIdList: number[] = [] // 학습지 선택 아이디리스트
  problemFilterType: common.ProblemFilterType = 'ALL'
  scoreList: (2 | 3 | 4)[] = [2, 3, 4] // 배점 - 전체면 null
  curriculumIdList: number[] = [] // 개념 아이디 (학습지 수정시 선택한 개념 아이디를 여기에 저장
  problemList:
    | {
        id: number
        tagTop: string | null
        baseWorkbookProblemId: number | null
      }[]
    | null = null
  selectedConceptIdList: number[] = [] // 선택한 유형별 개념
  selectedLittleChapterIdList: number[] = [] // 선택한 소단원별 개념

  constructor(data?: Partial<MakeWorksheetByPracticeTestOption>) {
    super()
    if (data) {
      Object.assign(this, data)
    }

    makeObservable(this, {
      filterId: observable,
      onlyAutoScorable: observable,
      excludeOOC: observable,
      practiceProblemIdList: observable,
      problemFilterType: observable,
      scoreList: observable,
      curriculumIdList: observable,
      problemList: observable,
      selectedConceptIdList: observable,
      selectedLittleChapterIdList: observable,
      params: computed,
    })
  }

  get params() {
    const curriculumIdList = toJS(this.curriculumIdList)
    return {
      filterId: this.filterId,
      scoreList: this.scoreList, // 배점 필터
      problemFilterType: this.problemFilterType, // 문제 타입
      onlyAutoScorable: this.onlyAutoScorable, // 자동채점여부
      excludeOOC: this.excludeOOC, // 교육과정 외 문제 제외
      curriculumIdList: curriculumIdList || null, // 교육과정 아이디 리스트
      problemList: this.problemList,
      selectedConceptIdList: this.selectedConceptIdList,
      selectedLittleChapterIdList: this.selectedLittleChapterIdList,
    }
  }
}
